module.exports = __webpack_public_path__ + "static/img/GooglePlay.6cc1ba7e.jpg";